import { userSliceActions } from "./reducers/user/user-Slice";
import { getProfile, onProfileChange } from "../features/profile/profileStore";
import { isAuthenticated, onTokenChange } from "../lib/api/tokenStore";

export const attachProfileBridge = (store) => {
  store.dispatch(userSliceActions.setUser(getProfile()));
  store.dispatch(userSliceActions.setAuthResolved(isAuthenticated()));

  const stopProfile = onProfileChange((profile) =>
    store.dispatch(userSliceActions.setUser(profile))
  );

  const stopToken = onTokenChange((token) =>
    store.dispatch(userSliceActions.setAuthResolved(Boolean(token)))
  );

  return () => {
    stopProfile();
    stopToken();
  };
};

export default attachProfileBridge;
